<template>
  <div class="navigation">
    <div>
        <img :src="current === 'recommend'?require('@/assets/img/navigation/A.png'):require('@/assets/img/navigation/B.png')" @click="childSetCurrent('recommend')"/>
        <span>推荐</span>
    </div>
    <div>
        <img :src="current === 'live'?require('@/assets/img/navigation/C.png'):require('@/assets/img/navigation/D.png')" @click="childSetCurrent('live')"/>
        <span>直播</span>
    </div>
    <div>
        <img :src="current === 'video'?require('@/assets/img/navigation/E.png'):require('@/assets/img/navigation/F.png')" @click="childSetCurrent('video')"/>
        <span>视频</span>
    </div>
    <div>
        <img :src="current === 'info'?require('@/assets/img/navigation/G.png'):require('@/assets/img/navigation/H.png')" @click="childSetCurrent('info')"/>
        <span>资讯</span>
    </div>
    <!-- <div>
        <img :src="current === 'my'?require('@/assets/img/navigation/I.png'):require('@/assets/img/navigation/J.png')" @click="childSetCurrent('my')"/>
        <span>智慧旅游</span>
    </div> -->
  </div>
</template>
<script>
export default {
  props:{
    current: {
      type: String,
      default: 'recommend'
    }
  },
  created(){
  },
  methods:{
    childSetCurrent(index){
      this.$emit('set-Current',index)
    }
  }

}
</script>
<style lang="less" scope>
.navigation{
    display:flex;
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 3.5rem;
    background: #EEE;
    div{
      display: flex;
      flex-direction: column;
      width: 25%;
      align-items: center;
      justify-content: center;
      img{
        width: 1.7rem
      }
      span{
        font-size: 0.8rem;  
        margin-top: 0.1rem;
      }
  }
}

@keyframes appear {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
